import api from "../lib/api";

const payloadFor = ({ productId, product_id, color = "", selectedColor = "", size = "", selectedSize = "", qty = 1 }) => ({
  productId: productId || product_id,
  color: selectedColor || color || "",
  size: selectedSize || size || "",
  qty: Math.max(1, Number(qty) || 1),
});

export const getCart = async () => {
  const { data } = await api.get("/cart");
  return data;
};

export const upsertCartItem = async (item) => {
  const { data } = await api.put("/cart/items", payloadFor(item));
  return data;
};

export const removeCartItem = async (item) => {
  const { data } = await api.delete("/cart/items", { data: payloadFor(item) });
  return data;
};

export const clearCart = async () => {
  const { data } = await api.delete("/cart");
  return data;
};
